// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-04301a96] .matchDialog .el-input__inner{border:1px solid #dcdfe6!important}", ""]);
// Exports
module.exports = exports;
